export default "__VITE_ASSET__Z10ozRcd__"